import React, { useState, useEffect, useRef } from 'react';
import { TextField, IconButton, Button, Menu, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DropdownWithCheckboxes from './DropdownWithCheckboxes';
interface ISearch {
  searchTerm: string;
  setSearchTerm: (search: string) => void;
  setIsDirty: (val: boolean) => void;
  selectedOptions: string[];
  setSelectedOptions: any;
  options: any[];
}
function SearchBar({ searchTerm, setSearchTerm, selectedOptions, setSelectedOptions, options, setIsDirty }: ISearch) {
  const textFieldRef = useRef<HTMLDivElement | null>(null); // Create a ref for the TextField
  // const [selected, setSelected] = useState<any[]>([selectedOption]);
  const handleSearchChange = (event: any) => {
    setSearchTerm(event.target.value);
    setIsDirty(true);
  };
  const handleSearchClear = () => {
    setSearchTerm('');
  };
  useEffect(() => {
    if (textFieldRef.current) {
      textFieldRef.current.focus(); // Focus the TextField
    }
  }, []);

  return (
    <div className="w-full pt-1 pb-4">
      <TextField
        variant="standard"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleSearchChange}
        fullWidth
        size="small"
        inputRef={textFieldRef}
        autoComplete="off"
        InputProps={{
          endAdornment: (
            <div style={{ display: 'flex' }}>
              {searchTerm ? (
                <IconButton onClick={handleSearchClear}>
                  <CloseIcon />
                </IconButton>
              ) : (
                <IconButton>
                  <SearchIcon />
                </IconButton>
              )}
            </div>
          )
        }}
        sx={{
          '& .MuiInput-underline:before': {
            borderBottom: 'none'
          },
          '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: 'none'
          },
          '& .MuiInput-underline:after': {
            borderBottom: 'none'
          },
          '& .MuiInput-input:focus': {
            outline: 'none',
            boxShadow: 'none'
          }
        }}
      />
      <div className="mt-2">
        <DropdownWithCheckboxes options={options} selected={selectedOptions} setSelected={setSelectedOptions} />
      </div>
    </div>
  );
}
export default SearchBar;
